import React from "react";
import { useTranslation } from "@lib/i18n";
import { string } from "prop-types";

import Layout from "@components/Layout/Layout";
import Typography from "@components/shared/Typography";
import { getStaticAssetURL } from "@lib/getStaticAssetURL";
import { useDefaultPreconfiguration } from "@hooks/useDefaultPreconfiguration";
import { getCarImagePath } from "@shared/v2/lib/getCarImagePath";

const ErrorPage = ({ title, description }) => {
  const { t } = useTranslation();
  const { id, label } = useDefaultPreconfiguration();

  return (
    <Layout>
      <div className="flex flex-col justify-center items-center gap-8 bg-primaryLight px-8 py-16 lg:flex-row lg:p-20 min-h-[calc(100dvh-7.5rem)]">
        <div className="flex flex-col justify-center gap-8 uppercase lg:justify-start lg:p-8">
          <h1 className="text-4xl text-primaryDark font-bold text-center uppercase">
            {title ?? t("errors.default")}
          </h1>
          {description && (
            <Typography className="text-center text-balance">
              {description}
            </Typography>
          )}
        </div>
        <img
          alt={label}
          className="w-70 sm:w-80 lg:w-auto"
          src={getStaticAssetURL(getCarImagePath(id))}
          title={label}
        />
      </div>
    </Layout>
  );
};

ErrorPage.propTypes = {
  title: string,
  description: string,
};

export default ErrorPage;
